import { z } from "zod/v4";

import { FileUIPartSchema } from "../files";

export const ToolErrorSchema = z.object({
  name: z.string(),
  message: z.string(),
});

export type ToolError = z.infer<typeof ToolErrorSchema>;

export const ToolExecutionResultSchema = z.object({
  success: z.boolean(),
  files: FileUIPartSchema.array().optional(),
  data: z.any(),
  error: ToolErrorSchema.optional(),
});

export type ToolExecutionResult<T = any> = Omit<
  z.infer<typeof ToolExecutionResultSchema>,
  "data"
> & { data: T };
